export const videoFormat = '.mp4 .avi .flv .3gp .m4v .mkv .mov .mpg .mpeg .mts .webm .wmv'
export const imageFormat = '.gif.jpg.jpeg.bmp.png'
export const officialDocFormat = '.jpg.jpeg.png.pdf'
//设计方案，评审意见等
export const schemeFormat = '.pdf.doc.docx.dwg.rar.zip.psd.bmp.gif.eps.ai.tif.txt'

export const cruiseItemCategorys: any[] = ['安全隐患', '问题上报', '日常巡查']

export type DialogSize = 'max' | 'medium' | 'small' | 'mini'